var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"editor"},domProps:{"innerHTML":_vm._s(_vm.value)}})}
var staticRenderFns = []

export { render, staticRenderFns }